export const quickLinks = [
    {
        id: 'course-reviews',
        title: '課程評價',
        description: '查看各科目的評分與同學心得分享',
        icon: 'rate_review',
        path: '/course-reviews',
        stats: '共 156 門課程',
    },
    {
        id: 'exam-archive',
        title: '考古題庫',
        description: '下載歷年考試題目，提升考試準備效率',
        icon: 'quiz',
        path: '/exam-archive',
        stats: '共 324 份考古題',
    },
    {
        id: 'cheat-sheets',
        title: '學習大抄',
        description: '同學分享的課程重點整理與學習筆記',
        icon: 'description',
        path: '/cheat-sheets',
        stats: '共 89 份資料',
    },
];

export const aboutSummary = {
    title: '關於台大資管系學會',
    description: '',
    mission: [
        '維護並更新考古題資料庫',
        '建立課程評價平台',
        '舉辦學術與聯誼活動',
        '服務系上同學學習需求',
    ],
    currentMembers: 15,
    establishedYear: 2010,
};

export const courses = [
    {
        id: 1,
        name: '資料庫管理系統',
        professor: '李教授',
        rating: 4.2,
        reviewCount: 28,
        semester: '112-2',
        category: '必修',
        department: 'IM',
        credits: 3,
    },
    {
        id: 2,
        name: '網路程式設計',
        professor: '張教授',
        rating: 4.5,
        reviewCount: 35,
        semester: '112-2',
        category: '選修',
        department: 'IM',
        credits: 3,
    },
    {
        id: 3,
        name: '資訊系統分析與設計',
        professor: '王教授',
        rating: 3.8,
        reviewCount: 22,
        semester: '112-2',
        category: '必修',
        department: 'IM',
        credits: 3,
    },
    {
        id: 4,
        name: '機器學習',
        professor: '陳教授',
        rating: 4.6,
        reviewCount: 41,
        semester: '112-2',
        category: '選修',
        department: 'IM',
        credits: 3,
    },
    {
        id: 5,
        name: '大學國文',
        professor: '王老師',
        rating: 3.8,
        reviewCount: 125,
        semester: '112-1',
        category: '校訂必修',
        department: 'General',
        credits: 2,
    },
    {
        id: 6,
        name: '環境生態學',
        professor: '林教授',
        rating: 4.2,
        reviewCount: 89,
        semester: '112-2',
        category: '通識',
        department: 'General',
        credits: 2,
    },
];

export const examFiles = [
    {
        id: 1,
        courseName: '資料庫管理系統',
        professor: '李教授',
        examType: '期末考',
        year: '112',
        semester: '2',
        fileUrl: '/files/database_final_112-2.pdf',
        uploadDate: '2024-06-15',
        downloads: 156,
    },
    {
        id: 2,
        courseName: '網路程式設計',
        professor: '張教授',
        examType: '期中考',
        year: '112',
        semester: '2',
        fileUrl: '/files/web_programming_midterm_112-2.pdf',
        uploadDate: '2024-04-20',
        downloads: 89,
    },
    {
        id: 3,
        courseName: '資訊系統分析與設計',
        professor: '王教授',
        examType: '期末考',
        year: '111',
        semester: '2',
        fileUrl: '/files/system_analysis_final_111-2.pdf',
        uploadDate: '2024-01-15',
        downloads: 203,
    },
    {
        id: 4,
        courseName: '程式設計',
        professor: '陳教授',
        examType: '小考',
        year: '112',
        semester: '1',
        fileUrl: '/files/programming_quiz_112-1.pdf',
        uploadDate: '2024-03-10',
        downloads: 67,
    },
];

export const cheatSheets = [
    {
        id: 1,
        title: '資料庫正規化重點整理',
        courseName: '資料庫管理系統',
        description: '包含1NF到BCNF的完整說明與範例',
        author: '學長A',
        fileUrl: '/files/database_normalization_notes.pdf',
        uploadDate: '2024-05-10',
        downloads: 234,
        tags: ['資料庫', '正規化', '理論'],
    },
    {
        id: 2,
        title: 'React Hooks 使用指南',
        courseName: '網路程式設計',
        description: 'useState, useEffect, useContext 等常用 Hooks 總整理',
        author: '學姐B',
        fileUrl: '/files/react_hooks_guide.pdf',
        uploadDate: '2024-04-25',
        downloads: 167,
        tags: ['React', 'JavaScript', '前端'],
    },
    {
        id: 3,
        title: '機器學習演算法比較表',
        courseName: '機器學習',
        description: '常見ML演算法的優缺點與適用場景比較',
        author: '同學C',
        fileUrl: '/files/ml_algorithms_comparison.pdf',
        uploadDate: '2024-03-15',
        downloads: 298,
        tags: ['機器學習', 'AI', '演算法'],
    },
];

// 幹部名單以「民國學年度」為 key。新增一屆的做法：
//   1. 照片放進 public/images/members/<學年>/
//   2. 在這裡加一個 key，avatar 路徑帶上同一個學年
// AboutUsPage 的學年切換按鈕是從這裡的 key 推導出來的，不需要另外註冊；
// 名單補上去按鈕就會出現，而且只要那一屆是當前學年就會自動成為預設。
//
// position 用中文（AboutUsPage 靠 '會長'/'部長' 分組），那是資料值不是介面文案，
// 詳見 AboutUsPage.js 裡的說明。
export const staffByYear = {
    114: [
        {
            id: 1,
            name: '游輝毅',
            position: '會長',
            avatar: '/images/members/114/joe.jpg',
        },
        {
            id: 2,
            name: '汪芷瑩',
            position: '副會長',
            avatar: '/images/members/114/angelica.jpg',
        },
        {
            id: 3,
            name: '周建凱',
            position: '學術部長',
            avatar: '/images/members/114/chou.jpg',
        },
        {
            id: 4,
            name: '鍾心哲',
            position: '資訊部長',
            avatar: '/images/members/114/justin.jpg',
        },
        {
            id: 5,
            name: '楊珮榆',
            position: '活動部長',
            avatar: '/images/members/114/annie.jpg',
        },
        {
            id: 6,
            name: '林采穎',
            position: '庶務部長',
            avatar: '/images/members/114/lin.jpg',
        },
        {
            id: 7,
            name: '蔡承佑',
            position: '總務部長',
            avatar: '/images/members/114/patrick.jpg',
        },
        {
            id: 8,
            name: '陳允直',
            position: '文宣部長',
            avatar: '/images/members/114/notStraight.jpg',
        },
    ],
    115: [
        {
            id: 1,
            name: '鍾心哲',
            position: '會長',
            avatar: '/images/members/115/鍾心哲.jpg',
        },
        {
            id: 2,
            name: '劉威廷',
            position: '副會長',
            avatar: '/images/members/115/劉威廷.jpg',
        },
        {
            id: 3,
            name: '張宇昌',
            position: '資訊部長',
            avatar: '/images/members/115/張宇昌.jpg',
        },
        {
            id: 4,
            name: '莊貴淳',
            position: '活動部長',
            avatar: '/images/members/115/莊貴淳.jpg',
        },
        {
            id: 5,
            name: '神秘人',
            position: '庶務部長',
            // 這位還沒有照片。刻意不填 avatar，而不是指向一個不存在的檔案——
            // 畫面上兩者都會顯示姓氏字的圓形框（AboutUsPage 的 Avatar fallback），
            // 但留著壞路徑會讓每次載入都多打一個 404，伺服器日誌也會被塞滿。
        },
        {
            id: 6,
            name: '田宏寬',
            position: '財務部長',
            avatar: '/images/members/115/田宏寬.jpg',
        },
        {
            id: 7,
            name: '吳丞妤',
            position: '文宣部長',
            avatar: '/images/members/115/吳丞妤.jpg',
        },
        {
            id: 8,
            name: '鄭安哲',
            position: '學術部長',
            avatar: '/images/members/115/鄭安哲.jpg',
        },
        {
            id: 9,
            name: '李昱辰',
            position: '學術部長',
            avatar: '/images/members/115/李昱辰.jpg',
        },
    ],
};
